import { useEffect, useState } from "react";
import IFSubMenu from "../components/IF_SubMenu";
import IFBanner from "../components/IF_Template/IF_banner";
import IFPricing from "../components/IF_Template/IF_Pricing";
import IFSwiper from "../components/IF_Swiper";
import IFHeading from "../components/IF_Heading";
import FadeIn from "../components/Animation/FadeIn";
import { getTrainer, getTrainerCache } from "../services";

function SafeJsonParse(str, fallback = []) {
    try {
        return JSON.parse(str);
    } catch {
        return fallback;
    }
}

export default function Trainer() {
    const cached = getTrainerCache();
    const [data, setDatas] = useState(() => cached || { datas: [], album: [] });
    const [load, setLoad] = useState(() => !cached || !cached.datas || cached.datas.length === 0);

    useEffect(() => {
        getTrainer().then((res) => {
            if (res && res.datas && res.datas.length > 0) {
                setDatas(res);
            }
            setLoad(false);
        });
    }, []);

    if (load || !data.datas || data.datas.length === 0) {
        return (
            <div className="min-h-[70vh] w-full flex items-center justify-center">
                <div className="w-12 h-12 rounded-full border-4 border-white/20 border-t-pink animate-spin" />
            </div>
        );
    }

    const programPricing = SafeJsonParse(data.datas[5]?.value, []);

    return (
        <div className="flex flex-col w-full overflow-x-hidden">
            <IFBanner
                src={data.datas[0]?.value ? process.env.REACT_APP_IMAGE_URL + data.datas[0].value : "/images/kinan.png"}
            >
                <FadeIn direction="left" duration={0.9}>
                    <div className="max-w-[600px]">
                        <IFSubMenu
                            as="h1"
                            text1={data.datas[1]?.value}
                            text2={data.datas[2]?.value}
                        />
                        <p className="text-xs sm:text-sm md:text-base text-gray-300 leading-relaxed mt-2 whitespace-pre-line">
                            {data.datas[3]?.value}
                        </p>
                    </div>
                </FadeIn>
            </IFBanner>

            <section className="py-12 md:py-16">
                <IFHeading>PERSONAL TRAINING PROGRAM</IFHeading>
                <IFPricing datas={programPricing}>
                    <div className="max-w-[800px] mx-auto text-center">
                        <FadeIn duration={0.9}>
                            <p className="text-sm md:text-base lg:text-lg text-gray-300 leading-relaxed whitespace-pre-line">
                                {data.datas[4]?.value}
                            </p>
                        </FadeIn>
                    </div>
                </IFPricing>
            </section>

            <IFSwiper data={data.album} />
        </div>
    );
}
